import { useLocation } from "react-router-dom";
import VerificationLayout from "../../components/verification/VerificationLayout.jsx";
import StatusBox from "../../components/verification/StatusBox.jsx";
import PatientDetails from "../../components/verification/PatientDetails.jsx";
import Button from "../../components/ui/Button.jsx";

export default function MilestoneError() {
  const location = useLocation();
  const patientData = location.state?.patientData || {
    firstname: "Unknown",
    lastname: "",
    participantId: "N/A",
  };

  const lastAction = location.state?.lastAction || {
    description: "Milestone recording failed",
    date: "",
  };

  return (
    <VerificationLayout title="Validation - Error">
      <StatusBox
        type="error"
        title="Milestone recording failed"
        message={
          <>
            An error occurred and the milestone could not be recorded.
            <br />
            If the issue persists, contact the support team.
          </>
        }
      />

      <PatientDetails patient={patientData} lastAction={lastAction} />

      <div className="text-center text-lg mt-12">
        <p>You may close this window and scan the QR code again</p>
      </div>
    </VerificationLayout>
  );
}